import React, { useContext, useEffect, useState } from "react";
import moment from "moment";

// Components //
import FormModal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";

// Styles //
import "./liderCard.scss";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// Services //
import { getToken, getUserFormDataByQuestionId, saveForm } from "../../../services/formServices";

export interface ICardRedLideres {
	profilePicture: string;
	name: string;
	companyName: string;
	companyRoleDescription: string;
	companyRole?: string;
	email?: string;
	mobile: number;
	documentId?: string;
	topics?: string;
	topic_1?: string;
	topic_2?: string;
	topic_3?: string;
	topic_4?: string;
	topic_5?: string;
}

const CardRedLideres = (props: ICardRedLideres) => {

	const [isOpenModalLiderContact, setIsOpenModalLiderContact] = useState<boolean>(false);
	const [isOpenModalLider, setIsOpenModalLider] = useState<boolean>(false);
	const registerDate = moment(Date.now()).format('DD-MM-YYYY');
	const [payloadLeaders, setPayloadLeaders] = useState(null);
	const Context = useContext(GlobalContext);

	const formModalLiderClose = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModalLider((setShow) => !setShow);
	};

	// Precarga los datos de los lideres cuando se da click en ver mas
	const handleModalLider = () => {
		setIsOpenModalLider(true);
		if (Context?.gigyaContext?.gigyaAccount)
			createPayload();
	};

	// Envia los datos de los lideres cuando se da click en Contactar
	const handleModalLiderContact = async () => {
		try {
			const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
			await saveForm(payloadLeaders, token);
			setIsOpenModalLider(false);
			setIsOpenModalLiderContact(true);
		} catch (error) {
			console.log(error);
		}
	};

	const handleCloseModalLiderContact = () => {
		setIsOpenModalLiderContact(false);
		document.body.style.overflow = "scroll";
	};

	//Obtiene los datos del lider desde el registro del form
	const getUserDataFromForm = async (documentId) => {
		const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
		return await getUserFormDataByQuestionId(token, 5, 'documentId', documentId);
	}

	const createPayload = async () => {

		const payload = {
			idForm: 7,
			answers: [],
		};

		const valuesLeader = ['name', 'mobile', 'email', 'companyName']
		const applicantLeaderData = await getUserDataFromForm(Context?.gigyaContext?.gigyaAccount?.data.docNumber)

		// Agrega los datos del lider que hace la solicitud
		if (applicantLeaderData.data.answerData) {

			Object.entries(applicantLeaderData.data.answerData).forEach(([key, value]) => {
				if (valuesLeader.includes(key))
					payload.answers.push({ contentfulId: key, answer: value });
			});
		}

		// Agrega los datos del lider al cual se desea contactar
		const leaderToContactData = await getUserDataFromForm(props.documentId)

		if (leaderToContactData.data.answerData) {

			Object.entries(leaderToContactData.data.answerData).forEach(([key, value]) => {
				if (valuesLeader.includes(key))
					//Se agrega el 2 al value para que coincida con el id del campo en contentful
					payload.answers.push({ contentfulId: key + 2, answer: value });
			});
		}
		payload.answers.push({ contentfulId: 'date', answer: registerDate })
		setPayloadLeaders(payload);
	}


	return (
		<>
			{/* MODAL LIDER MAS */}
			{isOpenModalLider && (
				<div className="modal-lider-more">
					<FormModal showModal={isOpenModalLider} onClose={formModalLiderClose}>
						<div className="m-modal-content-lider">
							<div className="lider-modal-top">
								<div className="lider-foto-small">
									<img src={props.profilePicture} />
								</div>
								<div className="lider-info-modal">
									<div className="lider-nombre-modal">
										{props.name}
									</div>
									<div className="lider-desc-modal">
										{props.companyRole}
									</div>
								</div>
							</div>
							<div className="lider-modal-bottom">
								<div className="lider-presentacion-modal">
									<p>
										{props.companyRoleDescription}
									</p>
								</div>
								<hr />
								<div className="contactar-btn">
									<p className="contactar-btn__text">
										<a href="javascript:void(0)" onClick={handleModalLiderContact}>CONTACTAR</a>
									</p>
								</div>
							</div>
						</div>
					</FormModal>
				</div>
			)}

			{/* MODAL LIDER CONTACT ADJUST CREATE X TO CLOSE*/}
			{isOpenModalLiderContact && (
				<div className="modal-lider-contact">
					<FormModal showModal={isOpenModalLiderContact} onClose={handleCloseModalLiderContact}>
						<div className="m-modal-content">
							<div>
								<img src="https://images.ctfassets.net/gkhyeghj07ak/7FYLcTh5b6QgRHqi9eD7vZ/c23ca55309a3ce14b6f800dff1b91bf8/Icon_contactar.svg" />
							</div>
							<h2 className="m-modal-content__title">
								Te pondremos en contacto <br /> con {props.name}
							</h2>
							<div className="m-modal-content__form">
								<p>Le comunicaremos a este usuario que te <br /> quieres contactar con él.</p>
								<p>Te notificaremos tan pronto tengamos una respuesta.</p>
							</div>
							<Button
								type="button"
								text="ACEPTAR"
								classname={`a-button__magenta m-modal__button confirm`}
								isDisabled={false}
								onClickAction={handleCloseModalLiderContact}
							/>
						</div>
					</FormModal>
				</div>
			)}

			<div className="m-cmnd-lider-card">
				<div className="lider-card-top">
					<div className="lider-foto">
						<img src={props.profilePicture} />
					</div>
				</div>
				<div className="lider-card-bottom">
					<div className="lider-info">
						<p className="lider-nombre">
							{props.name}
						</p>
						<p className="lider-desc">
							{props.companyRoleDescription}
						</p>
						<p className="razon-social">
							{props.companyName}
						</p>
					</div>
					<hr />
					<div className="view-more">
						<p className="view-more__text">
							<a href="javascript:void(0)" onClick={handleModalLider}>VER MÁS</a>
						</p>
					</div>
				</div>
			</div>
		</>
	);

}

export default CardRedLideres;